import calcAnnualVehicleElectricityCostsAllRates from '@generic/functions/calcAnnualVehicleElectricityCostsAllRates';

const calcAnnualVehicleElectricityCosts = (inputs) => {
  // apply all rates, take the cheapest
  const allRateCosts = calcAnnualVehicleElectricityCostsAllRates(inputs);
  return allRateCosts.sort((a, b) => a.total - b.total)[0];
};

export default calcAnnualVehicleElectricityCosts;
